import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
/* eslint-disable */
import { userLogin, logout as _logout, getInfo as _getInfo } from 'api/user';
import { utilCookies } from '@/util/cookies';
var state = {
  token: utilCookies.getToken(),
  //getToken(),
  name: '10000',
  staffId: '',
  staffName: '',
  staffDepartment: '',
  contractCount: {},
  avatar: '',
  roles: [],
  company_info: {},
  subProjectInfo: {}
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_STAFF_ID: function SET_STAFF_ID(state, staffId) {
    state.staffId = staffId;
  },
  SET_STAFF_NAME: function SET_STAFF_NAME(state, staffName) {
    state.staffName = staffName;
  },
  SET_STAFF_DEPARTMENT: function SET_STAFF_DEPARTMENT(state, staffDepartment) {
    state.staffDepartment = staffDepartment;
  },
  SET_CONTRACT_COUNT: function SET_CONTRACT_COUNT(state, contractCount) {
    state.contractCount = contractCount;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  COMPANY_INFO: function COMPANY_INFO(state, info) {
    state.company_info = info;
  },
  SUB_PROJECT_INFO: function SUB_PROJECT_INFO(state, info) {
    state.subProjectInfo = info;
  }
};
var actions = {
  setProjectInfo: function setProjectInfo(_ref, info) {
    var commit = _ref.commit;
    commit('SUB_PROJECT_INFO', info);
  },
  setUserInfo: function setUserInfo(_ref2, _ref3) {
    var commit = _ref2.commit;
    var staff_id = _ref3.staff_id,
      name = _ref3.name,
      department = _ref3.department;
    commit('SET_STAFF_ID', staff_id);
    commit('SET_STAFF_NAME', name);
    commit('SET_STAFF_DEPARTMENT', department);
  },
  setContractCount: function setContractCount(_ref4, contractCount) {
    var commit = _ref4.commit;
    commit('SET_CONTRACT_COUNT', contractCount);
  },
  // user login
  login: function login(_ref5, loginInfo) {
    var commit = _ref5.commit;
    return new Promise(function (resolve, reject) {
      userLogin(loginInfo).then(function (response) {
        utilCookies.setToken(response.data.token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref6) {
    var commit = _ref6.commit,
      state = _ref6.state;
    return new Promise(function (resolve, reject) {
      _getInfo(state.token).then(function (response) {
        var data = response.data;
        if (!data) {
          reject('Verification failed, please Login again.');
        }
        var roles = data.roles,
          name = data.name,
          avatar = data.avatar;

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }
        commit('SET_ROLES', roles);
        commit('SET_NAME', name);
        commit('SET_AVATAR', avatar);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref7) {
    var commit = _ref7.commit,
      state = _ref7.state;
    return new Promise(function (resolve, reject) {
      _logout(state.token).then(function () {
        utilCookies.removeToken();
        // commit('SET_TOKEN', '')
        // commit('SET_ROLES', [])
        // resetRouter()
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref8) {
    var commit = _ref8.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      utilCookies.removeToken();
      resolve();
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};